module.exports = __webpack_public_path__ + "img/iveco_thumbnail.9cd5c254.png";